import React from 'react';
import LoginComponent from '../components/Auth/Login/Login';

function LoginPage() {
  return <LoginComponent />;
}

export default LoginPage;
